import {
  DOCUMENT_MANAGEMENT_TYPE,
  VOSA_DOCUMENT_TYPE,
} from 'features/documents/types';
import { TASK_MANAGEMENT_TYPE } from 'features/tasks/constants';

const publicPaths = {
  loginPage: (redirectedFrom?: string) =>
    `/auth/login${redirectedFrom ? `?redirectedFrom=${redirectedFrom}` : ''}`,
  keycloakAuthenticationPage: () => `/auth/keycloak-authentication`,
};

const privatePaths = {
  portalPage: () => '/',
  notificationPage: () => '/notifications',

  //Administrative
  OfficeCalendarManagementPage: () => '/administrative/office-calendar',
  BodOpinionsPage: () => '/administrative/bod/opinions',
  BodResolutionsPage: () => '/administrative/bod/resolutions',
  BodReportsPage: () => '/administrative/bod/reports',
  PayrollsPage: () => '/administrative/payrolls',
  AddPayrollPage: () => '/administrative/payrolls/create',

  //Documents
  VOSADocumentsPage: (documentType: VOSA_DOCUMENT_TYPE) =>
    `/documents/vosa/${documentType}`,
  VOSADocumentDetailPage: (documentType: VOSA_DOCUMENT_TYPE, id: string) =>
    `/documents/vosa/${documentType}/${id}`,
  createVOSADocumentPage: (documentType: VOSA_DOCUMENT_TYPE) =>
    `/documents/vosa/${documentType}/create`,
  editVOSADocumentPage: (documentType: VOSA_DOCUMENT_TYPE, id: string) =>
    `/documents/vosa/${documentType}/${id}/edit`,
  documentManagementPage: (documentManagementType: DOCUMENT_MANAGEMENT_TYPE) =>
    `/documents/management/${documentManagementType}`,

  //Tasks:
  TaskListPage: () => '/tasks',
  TaskOversightPage: () => '/tasks/oversight',
  TaskManagementPage: (taskManagementType: TASK_MANAGEMENT_TYPE) =>
    `/tasks/management/${taskManagementType}`,

  //Work
  MyWorkPage: () => '/work/my-work',
  AddNewWorkPage: () => '/work/my-work/create',
  MyWorkDetailPage: (id: string) => `/work/my-work/${id}`,

  //User Profile
  UserProfilePage: () => '/my-profile',

  //Administration
  DepartmentManagementPage: () => '/administration/department-management',
  PositionManagementPage: () => '/administration/position-management',
  AccountManagementPage: () => '/administration/account-management',
  PermissionManagementPage: () => '/administration/permission-management',
  UserGroupManagementPage: () => '/administration/user-group-management',
  SignatureAccountManagementPage: () =>
    '/administration/signature-account-management',
};

const pathsMap = {
  ...publicPaths,
  ...privatePaths,
};

export type PathsMap = typeof pathsMap;

export const getPath = <TRoute extends keyof PathsMap>(
  route: TRoute,
  ...params: Parameters<PathsMap[TRoute]>
) => {
  const pathCb: (...args: any[]) => string = pathsMap[route];
  return pathCb(...params);
};
